import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import { withTranslation } from 'react-i18next';
import DeviationGrid from '../../DeviationGrid';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import { moveDeviationToPosition, removeDeviations } from '../../../actions';
import withCustomSetDeviations from '../../../_hocs/withCustomSetDeviations';
import withSelectedDeviations from '../../../_hocs/withSelectedDeviations';
import AddDeviationsButton from '../../../_partials/AddDeviationsButton';
import GroupOperationButton from '../../../_partials/GroupOperationButton';
import ManageableDeviation from '../../../_partials/ManageableDeviation';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import customSetDeviationManagerStyles from './CustomSetDeviationManager.scss';
const enhance = compose(withCustomSetDeviations, withSelectedDeviations, connectMediaStore(null, {
    moveDeviationToPosition,
    removeDeviations
}), withTranslation());
export class CustomSetDeviationManager extends React.Component {
    render() {
        const { sideBarContent, t } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            oneRowHeader: true,
            headerSubtitle: t('mediapopup.editYourDeviationSetHint'),
            headerExtrasRightZone: /*#__PURE__*/ React.createElement(AddDeviationsButton, {
                limit: this.getSelectionLimitRemaining(),
                disabled: !this.getCanAddMore()
            }),
            headerExtrasBottomZone: /*#__PURE__*/ React.createElement(SelectedItemsPanel, {
                extrasClassName: customSetDeviationManagerStyles['selected-items-extras'],
                extras: this.renderSelectedItemsPanelExtras(),
                showSelectionLimit: false
            }),
            scrollableContent: this.renderContent(),
            sideBarContent: sideBarContent
        }));
    }
    renderSelectedItemsPanelExtras() {
        return /*#__PURE__*/ React.createElement(GroupOperationButton, {
            onClick: this.onDeleteSelected
        }, this.props.t('mediapopup.itemMenu.delete'));
    }
    // Can we add more deviations to the set without breaking the selectionLimit?
    getCanAddMore() {
        const selectionLimitRemaining = this.getSelectionLimitRemaining();
        return selectionLimitRemaining === undefined ? true : selectionLimitRemaining > 0;
    }
    // How many deviations can we add to the set?
    getSelectionLimitRemaining() {
        const { selectionLimit, deviations } = this.props;
        return selectionLimit ? selectionLimit - deviations.length : selectionLimit;
    }
    renderContent() {
        const { deviations } = this.props;
        return /*#__PURE__*/ React.createElement(DeviationGrid, {
            deviations: deviations,
            deviationRenderer: this.deviationRenderer,
            moveDeviationToPosition: this.props.moveDeviationToPosition
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "onDeleteSelected", ()=>{
            this.props.selectedDeviations && this.props.removeDeviations(this.props.selectedDeviations);
        }), _define_property(this, "deviationRenderer", (deviation, index, deviations)=>{
            return /*#__PURE__*/ React.createElement(ManageableDeviation, {
                index: index,
                deviation: deviation
            });
        });
    }
}
export default enhance(CustomSetDeviationManager);

//# sourceMappingURL=CustomSetDeviationManager.js.map